import { z } from 'zod';

export const lockerHistoryOptionsSchema = z.object({
  lockers: z.array(
    z.object({
      name: z.string(),
      id: z.string(),
    })
  ),
  events: z.array(z.string()),
});

export type LockerHistoryOptions = z.infer<typeof lockerHistoryOptionsSchema>;

export const lockerHistorySchema = z.object({
  total: z.number(),
  data: z.array(
    z.object({
      id: z.string(),
      lockerName: z.string(),
      lockerType: z.string(),
      eventName: z.string(),
      eventTime: z.string(),
      receiverHouseNumber: z.string(),
      image: z.string().optional(),
    })
  ),
});

export type LockerHistory = z.infer<typeof lockerHistorySchema>;
